export function generateMetaTags(
  data,
  domain,
  pageDirectory,
  slug,
  imageUrl,
  robots
) {
  // console.log("robots",robots);
  // console.log("domain", domain);
  const robotsValue =
  //process.env.MONGO_CONFIG == "PROD"  ?  "index,follow" :
  domain !== "www.nivabupa.com"
    ? "noindex,nofollow"
    : robots == "Noindex"
    ? "noindex,nofollow"
    : "index,follow";
// console.log("processENV_MongoConfig",process.env.MONGO_CONFIG);
// console.log("robotsValue ----",robotsValue);
  return (
    <>
      <title>{data.title || ""}</title>
      <meta name="description" content={data.description || ""} />
      <meta property="og:title" content={data.ogTitle || data.title || ""} />
      <meta
        property="og:description"
        content={data.ogDescription || data.description || ""}
      />
      <meta
        property="og:url"
        content={data.ogURL || `${domain}/${pageDirectory}/${slug}`}
      />
      <meta property="og:image" content={data.ogImage || imageUrl || ""} />
      <link
        rel="canonical"
        href={`https://${domain}/${pageDirectory}/${slug}`}
      />
      <meta
        property="twitter:title"
        content={data.twitterTitle || data.title || ""}
      />
      <meta
        property="twitter:description"
        content={data.twitterDescription || data.description || ""}
      />
      <meta
        property="twitter:url"
        content={data.twitterURL || `${domain}/${pageDirectory}/${slug}`}
      />
      <meta
        property="twitter:image"
        content={data.twitterImage || imageUrl || ""}
      />
      <meta name="robots" content={robotsValue} />;
    </>
  );
}
